// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			
	}
};

(function () {  
	BoostPFS.inject(this);  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
			 if (!suggestionElement) suggestionElement = this.$uiMenuElement;   
		if (!searchElement) searchElement = this.$element;  
		if (!searchBoxId) searchBoxId = this.id; 
	};

	BoostPFS.prototype.beforeBuildSearchBox = function (id) {

		// Remove theme's instant search events
		var cloneSearchBar = jQ(id).clone();
		jQ(id).replaceWith(cloneSearchBar);      
		
		
		if (Utils.InstantSearch.isFullWidthMobile()) {
			jQ(id).removeAttr('autofocus');
			if (jQ(id).is(':focus')) {
				jQ(id).blur();
			}
		}
	};

	BoostPFS.prototype.afterCloseSuggestionMobile = function(searchBoxId, isCloseSearchBox) {
		// Close theme's search pop up
		if (isCloseSearchBox && window.$ && $.fancybox){
			$.fancybox.close(true);
		}
	};
  InstantSearchApi.afterCallAsync = function(result, callbackInstantSearchApi) {
    /* Call 3rd party api */
    if (typeof window.Locksmith === 'object' && result.products.length > 0) {
    var URLs = []
    var URLsCollection = []
    var totalUrls = []
    var grantedAccess = []
    var grantedAccessCollection = []
    //Create an array of products URLs
    for(var i = 0; i < result.products.length; i ++){
        URLs.push('/products/' + result.products[i].handle);
    }
    for(var i = 0; i < result.collections.length; i ++){
        URLsCollection.push('/collections/' + result.collections[i].handle);
    }
    totalUrls = URLs.concat(URLsCollection)
    jQ.ajax({
        method: 'GET',
        url: '/apps/locksmith/api/resources',
        data: { urls: totalUrls,},
        timeout: 1500,
	async: false,
        success: function(response) {
	   try {
            var resources = JSON.parse(response);
            for(var i = 0; i < URLs.length; i ++){
                //Checks that the response exists
                if(resources[URLs[i]]){
                //Checks that the access of the product has been granted
                if(resources[URLs[i]].access_granted || resources[URLs[i]].manual_lock){
                    //If the product is accesible add it to the array of the products
                    grantedAccess.push(result.products[i])
                }
                }
            }
            //Change array of products
            result.products = grantedAccess;
            //Same for collections
            for(var i = 0; i < URLsCollection.length; i ++){
                //Checks that the response exists
                if(resources[URLsCollection[i]]){
                //Checks that the access of the product has been granted
                if(resources[URLsCollection[i]].access_granted || resources[URLsCollection[i]].manual_lock){
                    //If the product is accesible add it to the array of the products
                    grantedAccessCollection.push(result.collections[i])
                }
                }
            }
            //Change array of collections
            result.collections = grantedAccessCollection;
            /* Build everything after getting instant search data */
            callbackInstantSearchApi(result);
	    } catch (error) {
		console.error(error);
                callbackFilterApi(result);	    
	    }
        },
        error: function() {
            /* Build everything after getting instant search data */
            callbackInstantSearchApi(result);
        },
    });
    } else {
        callbackInstantSearchApi(result);
    }
}
})();